import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import CommonNav from './CommonNav'

export default function TermsOfService() {
    return (
    <>
        <CommonNav></CommonNav>






    <h1>Terms of Service for SMS Notifications</h1>
    <p><strong>Effective Date:</strong> 06/01/2025</p>

    <p>By using <strong>MakoDesk</strong> ("we", "us", or "our"), including signing up to receive text message notifications or reminders, you agree to the following Terms of Service.</p>

    <h2>1. SMS Notifications</h2>
    <p>By providing your mobile phone number and opting in, you consent to receive SMS text messages from <strong>MakoDesk</strong>. Messages may include:</p>
    <ul>
    <li>Appointment or activity reminders</li>
    <li>Notifications regarding your account</li>
    <li>Important updates or alerts</li>
    </ul>
    <p>Message frequency may vary. Message and data rates may apply depending on your mobile plan and carrier.</p>

    <h2>2. Opt-In and Opt-Out</h2>
    <p>You may opt-in to receive SMS notifications during account registration or in your account settings.</p>
    <p>To stop receiving messages, you can:</p>
    <ul>
    <li>Text <strong>STOP</strong> to [short code or sender number]</li>
    <li>Or update your settings in your user profile</li>
    </ul>
    <p>After opting out, you may receive one final confirmation message. You may re-subscribe at any time.</p>

    <h2>3. User Responsibilities</h2>
    <p>You must provide a valid mobile number and keep it up to date. You are responsible for any charges from your mobile carrier related to text messages.</p>
    <p>We are not responsible for delays or failures in message delivery, which may be caused by factors outside our control (e.g., wireless carrier network issues).</p>

    <h2>4. Privacy</h2>
    <p>We respect your privacy. Your phone number and related personal data will be handled in accordance with our <a href="#">Privacy Policy</a>. We do not sell or share your phone number with third parties for marketing purposes.</p>

    <h2>5. Limitations of Liability</h2>
    <p>To the maximum extent permitted by law, <strong>MakoDesk</strong> shall not be liable for any indirect, incidental, or consequential damages arising from or relating to the SMS service.</p>

    <h2>6. Changes to This Agreement</h2>
    <p>We may update these Terms of Service at any time. Continued use of the service after such changes constitutes your acceptance of the revised terms.</p>

    <h2>7. Contact</h2>
    <p>If you have questions about these Terms of Service or the SMS notifications, contact us at:</p>
    <ul>
    <li><strong>Email:</strong> support@[makodesk.com]</li>
    <li><strong>Phone:</strong> (858) 555-1234</li>
    <li><strong>Mailing Address:</strong> tbd</li>
    </ul>

    <p><em>By using this service, you agree to these Terms of Service.</em></p>

    <a href="http://localhost:3000/viewSubRequest?substitute_job_id=1&sub_id=1">VOR</a>


    </ >
    );
}